<template>
  <dd-button
    :size="size"
    :color="ColorAssistant.ProjectColor"
    new-icon
    @click="handleClick()"
  ><i class="ddi ddi-task" />&nbsp;<span>New Task</span></dd-button>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import RouteAssistant from '@/helpers/route-assistant'
import ColorAssistant from '@/helpers/color-assistant'

export default defineComponent({
  name: 'NewTaskButton',

  props: {
    projectId: {
      type: Number,
      default: null,
    },
    projectName: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'large',
    },
    disableClick: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      RouteAssistant,
      ColorAssistant,
    }
  },
  methods: {
    handleClick() {
      if (this.disableClick) {
        return
      }
      if (this.projectId) {
        RouteAssistant.goToCreateTask(
          this.$router,
          this.$route.params.accountId,
          this.projectId,
          this.$permissions,
          this.projectName,
        )
      } else {
        RouteAssistant.goToGlobalCreateTask(
          this.$router,
          this.$route.params.accountId,
        )
      }
    },
  },
})
</script>
